<template>
  <div>
    <div class="listContent">
      <el-dialog title="切换工程" :visible.sync="dialogTableVisible">
        <el-table :data="projList">
          <el-table-column prop="name" label="名称"></el-table-column>
          <el-table-column prop="address" label="工程地址"></el-table-column>
          <el-table-column label="设置" width="150">
            <template slot-scope="scope">
              <span
                class="setProject"
                @click="toActive(scope.row.id)"
                v-if="scope.row.active == 0"
                >设为当前工程</span
              >
              <span class="lookMore" v-if="scope.row.active == 1"
                >当前工程</span
              >
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
      <div class="changeText">当前工程：{{ nowPro }}</div>
      <el-button
        class="changePro"
        type="primary"
        @click="openProjectSelector"
        plain
        >切换工程</el-button
      >
      <div class="searchContent">
        <div class="line"></div>
        <div class="lineT">验收报告列表</div>
      </div>
      <div class="listContain">
        <div class="tablelistBody">
          <el-table
            :data="dataList"
            style="width: 100%"
            size="medium"
            height="721px"
            v-loading="listLoading"
            @selection-change="handleSelectionChange"
            :cell-class-name="cellcb"
          >
            <el-table-column prop="name" label="验收报告名称" width="350">
              <template slot-scope="scope">
                <span
                  class="lookMore_name"
                  @click="
                    goToProjectCheck(
                      scope.row.type,
                      scope.row.projectId,
                      scope.row.workId
                    )
                  "
                  >{{ scope.row.name }}</span
                >
              </template>
            </el-table-column>
            <el-table-column prop="roadType" label="报告类型" width="200">
              <template slot-scope="scope">
                <span v-if="scope.row.type == 0">工程验收报告</span>
                <span v-if="scope.row.type == 1">作业验收报告</span>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="作业区域" width="300">
              <template slot-scope="scope">
                <span v-if="scope.row.type == 0">--</span>
                <span v-if="scope.row.type == 1">{{ scope.row.area }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="layers" label="验收发起时间" width="250">
              <template slot-scope="scope">
                <span>{{ scope.row.startTime }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="endTime"
              label="审批完成时间"
              width="250"
            ></el-table-column>
            <el-table-column
              prop="node"
              label="当前流程节点"
              width="150"
            ></el-table-column>
            <el-table-column label="操作" width="">
              <template slot-scope="scope">
                <!-- <span class="lookMore" @click="toInfo(scope.row)"
                  >发起验收</span
                > -->
                <span
                  class="lookMore"
                  @click="
                    goToProjectCheck(
                      scope.row.type,
                      scope.row.projectId,
                      scope.row.workId
                    )
                  "
                  >查看</span
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <el-pageCover
      class="pageBlock"
      :style="'position:absolute;right:20px;top:845px'"
      :pageMsg="pageMsg"
      @sizeChange="pageSizeChange"
      @currentChange="currentPageChange"
    ></el-pageCover>
  </div>
</template>

<script>
import {
  getReports as fetchDtList,
  getEnginList,
  //   getWorks,
  activeEngin,
} from "../../utils/api";
import roleMixin from "../../utils/roleMixin";
import mixinList from "../../utils/mixinList";

import ElPageCover from "../../components/overall/ElPageCover";
export default {
  name: "app",
  mixins: [roleMixin, mixinList],
  data() {
    return {
      nowPro: "",
      dialogTableVisible: false,
      projList: [],
      listLoading: false,
      input1: "",
      roadTypeList: this.$store.state.roadType,
      addRoadTypeList: this.$store.state.roadTypeOutAll,
      list: [{}],
      pageMsg: {
        pageSize: 10,
        pageNo: 1,
        totalRecords: 0,
      },
      search: {
        pageSize: 10,
        pageNo: 1,
        projectId: "",
      },
      modelObj: {},
      activeObj: {
        active: "0",
      },
      pickerOptions: {},
      deleteStr: "",
      fieldKey: "ids",
      arrowList: [
        {
          name: "工程中心",
          path: "/transfer/engineeringCenter",
        },
        {
          name: "工程验收",
          path: "",
        },
      ],
    };
  },
  computed: {
    rules: function () {
      return {
        name: [{ required: true, message: "必填" }],
        roadType: [{ required: true, message: "必填" }],
      };
    },
  },
  created() {},
  mounted() {
    //console.log(this.$store.state.arrowList)

    this.getProjectList();
    this.$store.commit("setArrowList", this.arrowList);
  },
  methods: {
    fetchDtList,
    goToProjectCheck(t, p, w) {
      if (t == 0) {
        this.$router.push({
          path: "/transfer/projectCheck",
          query: { projectId: p },
        });
      } else {
        this.$router.push({
          path: "/transfer/workCheck",
          query: { workId: w },
        });
      }
    },
    openProjectSelector() {
      this.dialogTableVisible = true;
      // this.getProjectList();
    },
    toActive(setId) {
      let params = {
        id: setId,
      };
      activeEngin(params).then(() => {
        this.getProjectList();
      });
    },
    getProjectList() {
      getEnginList({ pageSize: 1000 }, { listKey: "list" }).then((res) => {
        this.projList = res.data.content.info.list;
        const currentProject = (this.projList || []).find(
          (item) => item.active == 1
        );
        this.projectId = currentProject.id;
        this.nowPro = currentProject.name;
        this.$store.commit("setProjectId", this.projectId);
        this.search.projectId = currentProject.id;
        this.doSearch();
      });
    },
    cellcb(row) {
      if (row.row.sourceType === 0) {
        return "myCell";
      }
    },
    // getDataList: function(){
    //     fetchDtList(this.search).then(res => {
    //         //console.log(res)
    //         this.list = addOrder(res.data.content.info.list)
    //         this.pageMsg = this.pageAssign(res.data.content.info);
    //     })
    // },
    //鼠标点击查找按钮，先对pageNo置1
    doSearchClick: function () {
      this.search.pageNo = 1;
      this.getDataList(this.search, { listKey: "list" });
    },
    doSearch: function () {
      this.getDataList(this.search, { listKey: "list" });
    },
    // toActive: function(setId){
    //     let params = {
    //         id: setId
    //     }
    //     activeEngin(params).then(res => {
    //         //console.log(res)
    //         this.getDataList(this.search, { listKey: "list" });
    //     })
    // },
    handleSelectionChange: function (val) {
      //console.log(val)
      let deleteArr = [];
      for (let i = 0; i < val.length; i++) {
        deleteArr.push(val[i].id);
      }
      this.deleteStr = deleteArr.join(",");
    },
    toInfo: function (e) {
      //console.log(e)
      if (e.roadType == 1) {
        this.$router.push({ name: "UnRoadInfo", query: { id: e.id } });
      } else {
        this.$router.push({ name: "RoadInfo", query: { id: e.id } });
      }
    },
  },
  components: {
    ElPageCover,
  },
};
</script>
<style lang="scss">
.myCell .el-checkbox__input {
  display: none;
}
</style>
<style lang="scss" scoped="">
.listContent {
  height: 790px;
  width: 98.5%;
  margin: 0 auto;
  background-color: #ffffff;
  position: relative;
  .searchContent {
    height: 40px;
    width: 80%;
    position: relative;
    .line {
      width: 4px;
      height: 14px;
      background: #f56c6c;
      position: absolute;
      top: 13px;
      left: 24px;
    }
    .lineT {
      line-height: 22px;
      height: 22px;
      position: absolute;
      color: rgba(0, 0, 0, 0.8);
      font-size: 14px;
      font-weight: bold;
      top: 9px;
      left: 36px;
    }
    // padding: 17.5px 17px;
  }
  .changeText {
    line-height: 28px;
    color: rgba(0, 0, 0, 0.8);
    font-size: 14px;
    font-weight: bold;
    position: absolute;
    right: 112px;
    top: -42px;
    z-index: 500;
  }
  .changePro {
    position: absolute;
    width: 88px;
    height: 32px;
    text-align: center;
    // line-height: 30px;
    font-size: 14px;
    // background: rgba(245, 108, 108, 0.1);
    // border-radius: 2px;
    // border: 1px solid #F56C6C;
    // color: #F56C6C;
    // cursor: pointer;
    right: 0;
    top: -45px;
    z-index: 500;
  }
}
.listContain {
  width: 98.5%;
  margin: 0 auto;
}
.lookMore {
  display: inline-block;
  font-size: 14px;
  color: #e24747;
  background: rgba(255, 232, 232, 1);
  border: 1px solid rgba(226, 71, 71, 1);
  border-radius: 16px;
  padding: 4px 16px;
  margin-left: 10px;
  cursor: pointer;
}
.setProject {
  display: inline-block;
  font-size: 14px;
  color: #555555;
  background: rgba(238, 236, 236, 1);
  border: 1px solid rgba(196, 196, 196, 1);
  border-radius: 16px;
  padding: 4px 16px;
  cursor: pointer;
}
.lookMore_name {
  cursor: pointer;
  text-decoration: underline;
}
</style>